import React, { useState, useEffect, useRef } from 'react'
import { Button, OnboardTitle, OnboardSubtitle } from 'components/Antifraude'
import { Box, InputAdornment, TextField } from '@mui/material'
import { Email, LockClockOutlined } from '@mui/icons-material/'
import cloneDeep from 'lodash/cloneDeep'
import Reaptcha from 'reaptcha'

import { ValidateEmail } from 'utils/validators'

import { recoverPassword } from 'services/apiAuth'

import { ROUTE_CONSTANTS } from 'utils/constants/routeConstants'
import { toast } from 'react-toastify'
import { gotoUrl } from 'utils/functions'

import styles from './styles'

const PasswordRecover = () => {
  const classes = styles()

  const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY

  const captcha = useRef()

  const [formValues, setFormValues] = useState({
    email: '',
  })

  const [loading, setLoading] = useState(false)

  const [canSend, setCanSend] = useState(false)
  const [validEmail, setValidEmail] = useState(false)
  const [validCaptcha, setValidCaptcha] = useState(false)

  const handleChange = (event) => {
    const key = event.target.name
    const currentValue = cloneDeep(formValues)
    currentValue[key] = event.target.value
    setValidEmail(ValidateEmail(currentValue[key]))
    setFormValues(currentValue)
  }

  const validateCaptcha = () => {
    setValidCaptcha(true)
  }

  const expiredCaptcha = () => {
    setValidCaptcha(false)
    captcha.current.reset()
    captcha.current.execute()
    setValidCaptcha(true)
  }

  const onRenderCaptcha = () => {
    captcha.current.execute()
  }

  const handleSubmit = async () => {
    setLoading(true)
    const data = { email: formValues.email }
    recoverPassword(data)
      .then((response) => {
        if (response.status === 204) gotoUrl(ROUTE_CONSTANTS.EMAIL_SENT)
      })
      .catch((error) => {
        toast.error(`Erro: ${error?.response?.data?.detail}`)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  useEffect(() => {
    setCanSend(validEmail && validCaptcha)
  }, [validEmail, validCaptcha])

  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <div className={classes.titleBar}>
          <div className={classes.locker}>
            <LockClockOutlined fontSize="inherit" />
          </div>
          <OnboardTitle>Esqueceu sua senha?</OnboardTitle>
          <OnboardSubtitle>
            Por favor, informe o e-mail associado à sua conta para enviarmos um
            link com instruções de recuperação de acesso:
          </OnboardSubtitle>
        </div>
        <Box
          component="form"
          className={classes.formBox}
          noValidate
          autoComplete="on"
        >
          <TextField
            required
            fullWidth
            name="email"
            label="Email"
            value={formValues.email}
            onChange={handleChange}
            type="text"
            size='small'
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Email />
                </InputAdornment>
              ),
            }}
          />

          <Button loading={loading} onClick={handleSubmit} disabled={!canSend}>
            Enviar e-mail de recuperação
          </Button>
        </Box>
      </div>
      <Reaptcha
        ref={captcha}
        sitekey={RECAPTCHA_SITE_KEY}
        onVerify={validateCaptcha}
        onExpire={expiredCaptcha}
        onRender={onRenderCaptcha}
        size="invisible"
        badge="inline"
      />
    </div>
  )
}

export default PasswordRecover
